import { useEffect } from 'react';

import { Auth0ContextInterface, User } from '@auth0/auth0-react';
import { Outlet, createRootRouteWithContext, useLocation } from '@tanstack/react-router';

import ModalManager from 'src/components/modals/ModalManager';
import { AnalyticsProvider } from 'src/contexts/AnalyticsContext';

export interface RouterContextWithAuth {
    auth: Auth0ContextInterface<User>;
}

export const Route = createRootRouteWithContext<RouterContextWithAuth>()({
    component: RootLayout,
    notFoundComponent: () => <div>404 - Not Found</div>,
});

function RootLayout() {
    const location = useLocation();

    // Scroll to top on route change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <AnalyticsProvider>
            <ModalManager>
                <Outlet />
            </ModalManager>
        </AnalyticsProvider>
    );
}
